module.exports = __webpack_public_path__ + "img/bj_tx@2x.7403132e.png";